module.exports = __webpack_public_path__ + "img/local-25.159f66be.jpg";